import React, { useEffect, useState } from "react";
import "./Load.scss";
import logo from "../../assets/logo/white_logo.png";

const Loader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`loader-container ${loading ? "loading" : ""}`}>
      <div className="loader-ring">
        <img src={logo} alt="V-Ex Logo" className="logo-img" />
      </div>
    </div>
  );
};

export default Loader;
